<template>
  <el-container class="module-container report-module">
    <el-header height="auto" class="module-container__header">
      <div class="module-header">
        <div class="module-header-top">
          <div class="title">
            {{ $t('Reports') }}
          </div>
          <ReportDialog v-if="isDeveloper"
                        :project-id="projectId"
                        class="report-dialog-web" />
        </div>
      </div>
    </el-header>
    <el-main class="module-container__main">
      <ReportDialog v-if="isDeveloper"
                    :project-id="projectId"
                    class="report-dialog-mobile" />
      <VisitReport :project-id="projectId" />
      <StockAvailability :project-id="projectId" />
      <FacingReports :project-id="projectId" />
      <DiscardReport :project-id="projectId" />
    </el-main>
  </el-container>
</template>

<script>
import { mapState } from 'vuex';
import ReportDialog from '@/modules/report/components/ReportDialog';
import VisitReport from '../visit-report';
import StockAvailability from '../stock-availability';
import FacingReports from '../facing-reports';
import DiscardReport from '../discard-report';

export default {
  name: 'ReportIndex',
  components: {
    VisitReport,
    StockAvailability,
    FacingReports,
    DiscardReport,
    ReportDialog
  },
  props: {
    projectId: {
      type: [String, Number],
      required: true
    }
  },
  computed: {
    ...mapState(['Account']),
    isDeveloper() {
      return this.Account.active.data.developer;
    }
  }
};
</script>

<style lang="scss">
.report-module {
  .report-module-title {
    margin: 0;
  }

  .el-table {
    margin: 10px 0;

    &__header-wrapper {
      .el-table__header {
        .cell {
          display: flex;
          align-items: center;

          .caret-wrapper {
            justify-content: center;
          }
        }
      }
    }
  }

  .module-container__header {
    height: 48px !important;
    padding: 0 20px;

    @include breakpoint(lg-max) {
      display: none;
    }
  }

  .report-dialog-web {
    @include breakpoint(lg-max) {
      display: none;
    }
  }

  .report-dialog-mobile {
    display: none;

    @include breakpoint(lg-max) {
      display: flex;
    }
  }
}
</style>
